import { Box, FormControl, TextField, Typography, Button, Collapse } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Add } from "@mui/icons-material";
import { ReactEventHandler, MouseEventHandler } from "react";
import { RequiredIndicator } from "../../App/Components/Forms/formHelpers";

export default function SaveTemplateOptions({
  showSaveTemplate,
  templateName,
  templateVisibility,
  handleTemplateNameChange,
  handleTemplateVisbilityChange,
  handleSaveTemplateNow,
  disableButton,
  disableMessage,
}: {
  showSaveTemplate: boolean;
  handleTemplateNameChange: ReactEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  handleTemplateVisbilityChange: (e: SelectChangeEvent<string>) => void;
  handleSaveTemplateNow: MouseEventHandler<HTMLButtonElement>;
  templateName: string;
  templateVisibility: string;
  disableButton: boolean;
  disableMessage?: string;
}) {
  return (
    <Collapse in={showSaveTemplate} timeout="auto">
      <Box sx={{ my: 2 }}>
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2 }}>
          <Box sx={{ flex: 2 }}>
            <Typography sx={{ mt: 0, mb: 0 }} variant="h6" component="div">
              Template Name
              <RequiredIndicator />
            </Typography>
            <FormControl fullWidth sx={{}}>
              <TextField
                id="outlined-multiline-flexible"
                multiline
                maxRows={4}
                onChange={handleTemplateNameChange}
                value={templateName}
                data-test="template-name"
              />
            </FormControl>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ mt: 0, mb: 0 }} variant="h6" component="div">
              Visibility Status
            </Typography>
            <FormControl fullWidth>
              <Select id="Visibility" value={templateVisibility} onChange={handleTemplateVisbilityChange}>
                <MenuItem value={"Public"}>Public</MenuItem>
                <MenuItem value={"Private"}>Private (Only Visible to You)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box sx={{ mt: 1 }}>
          <Button
            data-test="create-template-button"
            id="create-template-button"
            disabled={disableButton}
            onClick={handleSaveTemplateNow}
            startIcon={<Add />}
          >
            Create Template Now
          </Button>
          {disableMessage && disableMessage.length ? (
            <Typography
              sx={{ mt: 0, mb: 0 }}
              variant="caption"
              component="span"
              color={"error"}
              data-test="create-template-error"
            >
              {disableMessage}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Collapse>
  );
}
